import { createContext, useContext } from 'react';

import {
  HoldingAvailability,
  HoldingAvailabilityStatus,
  ILLLink,
} from '@app/components';

export interface SummaryAvailability {
  status: HoldingAvailabilityStatus;
  isRequestable: boolean;
  isRTACApplicable: boolean;
  hasVolumes: boolean;
  isInSpecialCollection: boolean;
  isEveryItemInSpecialLocation: boolean;
  hasItems?: boolean;
  hasHoldings?: boolean;
  copiesRemaining?: { available: number; total: number };
  ILLLinks?: ILLLink[];
}

export interface RecordAvailability {
  availabilityData: HoldingAvailability[];
  summaryAvailability: SummaryAvailability;
}

export interface AvailabilityContextProps {
  isAvailabilityLoading: boolean;
  availability: Record<string, RecordAvailability>;
  ILLLinks: Record<string, ILLLink[]>;
  getAvailability: (id: string | string[], pageNumber?: number) => void;
}

export const AvailabilityContext = createContext<AvailabilityContextProps>(
  null!
);

export const useAvailabilityContext = (): AvailabilityContextProps =>
  useContext(AvailabilityContext);
